import { render, staticRenderFns } from "./InformationTextBlock.vue?vue&type=template&id=53574061&scoped=true&"
import script from "./InformationTextBlock.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InformationTextBlock.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./InformationTextBlock.vue?vue&type=style&index=0&id=53574061&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53574061",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53574061')) {
      api.createRecord('53574061', component.options)
    } else {
      api.reload('53574061', component.options)
    }
    module.hot.accept("./InformationTextBlock.vue?vue&type=template&id=53574061&scoped=true&", function () {
      api.rerender('53574061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuInformation/components/InformationTextBlock.vue"
export default component.exports